import BaseModel from "../models/BaseModel";
import BaseModelReference from "../models/BaseModelReference";
import ConnectableObject from "../models/ConnectableObject";
import type TreeNodeInfo from "../models/TreeNodeInfo";
import TreeViewModel, { DragMode, DropResult } from "../models/TreeviewModel";

export default class BaseModelReferenceTreeviewModel extends TreeViewModel {
  constructor(obj: BaseModel) {
    super(obj);
  }

  get typedObj(): BaseModelReference {
    return this.obj as BaseModelReference;
  }

  get isSelectable(): boolean {
    return false;
  }

  get isFolder(): boolean {
    return this.typedObj.usefromRefencedTreeviewObject.showChildern || false;
  }

  getChildCollectionEx(parentTreeNodeInfo: TreeNodeInfo): Array<TreeNodeInfo> | undefined {
    if (this.typedObj.usefromRefencedTreeviewObject.showChildern) {
      const referencedObject = this.typedObj.referencedObject;
      if (!referencedObject || this.isReferencedObjectAlreadyInParentPath(parentTreeNodeInfo, referencedObject)) {
        return undefined;
      }
      return this.typedObj.referencedObject?.treeViewModel.getChildCollectionEx(parentTreeNodeInfo);
    }
    return undefined;
  }

  private isReferencedObjectAlreadyInParentPath(
    parentTreeNodeInfo: TreeNodeInfo,
    referencedObject: BaseModel,
  ): boolean {
    let current = parentTreeNodeInfo;

    while (current && current.obj == this.typedObj) {
      const parent = current.parentTreeNodeInfo;
      if (!parent) {
        return false;
      }
      current = parent;
    }

    while (current) {
      if (current.obj == referencedObject) {
        return true;
      }

      if (current.obj.className == "BaseModelReference") {
        const reference = current.obj as BaseModelReference;
        if (reference.referencedObject == referencedObject) {
          return true;
        }
      }

      const parent = current.parentTreeNodeInfo;
      if (!parent) {
        break;
      }
      current = parent;
    }

    return false;
  }

  getDisableEdit(): boolean {
    return true;
  }

  getTagNeeded(): boolean {
    return true;
  }

  getTitlePrefix(): string | JSX.Element {
    if (this.typedObj.overwritePrefix) {
      return this.typedObj.overwritePrefix;
    } else {
      return super.getTitlePrefix();
    }
  }

  getTitlePostfix(): string | JSX.Element {
    if (this.typedObj.overwritePostfix != undefined) {
      return this.typedObj.overwritePostfix;
    } else if (this.typedObj.referencedObject && this.typedObj.usefromRefencedTreeviewObject.titlePostfix) {
      return this.typedObj.referencedObject.treeViewModel.getTitlePostfix();
    } else {
      return super.getTitlePostfix();
    }
  }

  getFullTitle(isExpanded: boolean): string | undefined | JSX.Element {
    if (this.typedObj.overwriteFullTitle) {
      return this.typedObj.overwriteFullTitle;
    }

    if (this.typedObj.usefromRefencedTreeviewObject.fullTitle) {
      return this.typedObj.referencedObject?.treeViewModel.getFullTitle();
    } else {
      return super.getFullTitle();
    }
  }

  get icon(): any | undefined {
    if (this.typedObj.overwriteIcon) {
      return this.typedObj.overwriteIcon;
    }

    if (this.typedObj.usefromRefencedTreeviewObject.icon) {
      return this.typedObj.referencedObject?.treeViewModel.icon;
    }
    return undefined;
  }

  handleOpen(): boolean {
    return false;
  }

  handleDeconnect() {
    if (this.typedObj.onDisconnect) {
      return this.typedObj.onDisconnect();
    } else {
      const referencedObject = this.typedObj.referencedObject;
      const parent = this.typedObj.parent as BaseModel;

      if (referencedObject?.isConnectableObject && parent.isConnectableObject) {
        const connection = (referencedObject as ConnectableObject).getConnectionWith(parent as ConnectableObject);
        if (connection) {
          connection.delete();

          parent.raiseOnChange("childCollection");

          return true;
        }
      }
    }
    return false;
  }

  handleDoubleClick(): boolean {
    if (this.typedObj.referencedObject?.treeViewModel.hasOpenButton) {
      return this.typedObj.referencedObject?.treeViewModel.handleOpen();
    }

    return false;
  }

  getButtons(): JSX.Element[] | undefined {
    let res = [super.inlineButton_Reference()];

    const referencedObject = this.typedObj.referencedObject;
    const parent = this.typedObj.parent as BaseModel;

    let enableUnlink = false;
    if (parent && referencedObject?.isConnectableObject) {
      const connection = (referencedObject as ConnectableObject).getConnectionWith(parent as ConnectableObject);
      enableUnlink = connection != undefined;
    }

    if (this.typedObj.onDisconnect) {
      enableUnlink = true;
    }

    if (enableUnlink) {
      res.push(super.inlineButton_Deconnect("baseModelReferenceTreeviewModel.deleteConnection")); // no itx
    }

    const b1 = this.typedObj.referencedObject?.treeViewModel.getButtons();
    if (this.typedObj.usefromRefencedTreeviewObject.menuButtons && b1) {
      res = [...b1, ...res];
    }

    if (this.typedObj.additionalInlineButtons) {
      res = [...res, ...this.typedObj.additionalInlineButtons];
    }

    return res;
  }
  allowDrag(): boolean {
    return true;
  }
  async handleDrop2(mode: DragMode, obj: BaseModel): Promise<DropResult> {
    const refObj = this.typedObj as BaseModelReference;

    if (refObj.parent?.className == obj?.parent?.className) {
      const parent = refObj.parent as BaseModel;

      if (parent.treeViewModel) {
        return parent.treeViewModel.handleDrop2(mode, obj);
      }
    }

    return new DropResult(false);
  }

  get contextMenuItems(): any {
    return {
      items: [],
    };
  }
}
